export const Api = {
  url: process.env.REACT_APP_API_URL ?? '',
  version: 'v1',
} as const;
